import type { ReactNode } from 'react';
import { ListableInfo } from '@ics-portal/guardian';
import { type ComponentExternalIdentifier } from '@gql/graphql';
import { type Maybe } from '@models/Maybe';

interface ExternalIdentifiersProps {
    externalIdentifiers?: Maybe<ComponentExternalIdentifier[]>;
    icsPortalSource?: Maybe<string>;
}

export function ExternalIdentifiers({
    externalIdentifiers,
    icsPortalSource,
}: ExternalIdentifiersProps): ReactNode {
    const isEmpty =
        (!externalIdentifiers || externalIdentifiers.length === 0) &&
        !icsPortalSource;

    if (isEmpty) {
        return <p>No external identifiers found.</p>;
    }

    return (
        <div className="flex flex-column gap-2 py-sm">
            {typeof icsPortalSource === 'string' &&
            icsPortalSource.length > 0 ? (
                <ListableInfo
                    key="icsPortalSource"
                    size="md"
                    label="Source: ICS Portal"
                    value={icsPortalSource}
                    wrap
                />
            ) : null}
            {Array.isArray(externalIdentifiers) &&
            externalIdentifiers.length > 0
                ? externalIdentifiers.map((ei) => (
                      <ListableInfo
                          key={ei.id}
                          size="md"
                          label={`Source: ${ei.source}`}
                          value={ei.externalIdentifier}
                          wrap
                      />
                  ))
                : null}
        </div>
    );
}
